import LazyWrapper from './LazyWrapper';

export default LazyWrapper;
